<!-- Logo -->
<div class="cw-global-menu-logo-container">
  <div
    class="cw-global-menu-logo"
    [ngStyle]="{background: 'url(' + bigLogoPath + ') center no-repeat', 'background-size': 'contain'}"
  [hidden]="!showGlobalMenuTexts"></div>
  <div
    [ngStyle]="{background: 'url(' + smallLogoPath + ') center no-repeat', 'background-size': 'contain'}"
    class="cw-global-menu-logo-small"
  [hidden]="showGlobalMenuTexts"></div>
</div>

<!-- Hauptmodule -->
<ul class="cw-global-menu-list">
  <!--
  Direktiven routerLink & routerLinkActive (vorherige Version ohne Child-Menüs
  routerLink="/{{globalMenuItem.name}}"
  routerLinkActive="cw-global-menu-active"
  -->
  @for (globalMenuItem of globalMenu; track globalMenuItem) {
    <li
      class="cw-flex-row cw-global-menu-list-item"
            [ngClass]="{
                'cw-global-menu-active':
                    activeRouteName === globalMenuItem.name || activeRouteName.split('/')[0] === globalMenuItem.name,
            }">
      <span
        class="cw-flex-row"
        [ngClass]="{'cw-global-menu-active': activeRouteName === globalMenuItem.name}"
        matTooltip="{{ translateMenuItemToTranslationKey(globalMenuItem) | translate }}"
        [matTooltipDisabled]="showGlobalMenuTexts"
        [matTooltipPosition]="'after'"
        (click)="onClickMenu(globalMenuItem)">
        <!--
        TODO
        In der Backend Config gibt es noch veraltete Icons, die man auf FaIcon umziehen muss
        Deshalb wird unten zwischen den alten Icons und den neuen faIcons differenziert
        -->
        @if (globalMenuItem.faIcon) {
          <fa-icon
            class="cw-global-menu-list-icon"
          [icon]="$any(globalMenuItem.faIcon)"></fa-icon>
        }
        @if (globalMenuItem.icon) {
          <div class="cw-global-menu-list-icon {{ globalMenuItem.icon }}"></div>
        }
        <span [hidden]="!showGlobalMenuTexts" class="cw-global-menu-list-text">
          {{ translateMenuItemToTranslationKey(globalMenuItem) | translate }}
        </span>
        <!-- Submenü Pfeile - nur anzeigen wenn sidebar geöffnet ist -->
        @if (showGlobalMenuTexts) {
          <!-- Platz für die Pfeile reservieren, auch wenn keine children vorhanden -->
          <span class="cw-global-menu-arrow-slot">
            @if (globalMenuItem.children) {
              <fa-icon [icon]="globalMenuItem.showChildren ? 'chevron-down' : 'chevron-right'"> </fa-icon>
            }
          </span>
        }
      </span>
    </li>
    @if (globalMenuItem.children && globalMenuItem.showChildren) {
      @for (globalMenuItemChildren of globalMenuItem.children; track globalMenuItemChildren) {
        <li class="cw-flex-row cw-global-menu-list-item cw-global-submenu">
          <span
            class="cw-flex-row"
            [ngClass]="{'cw-global-submenu-active': activeSubMenu === globalMenuItemChildren.name}"
                        matTooltip="{{
                            (translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren) | translate) !== translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren)
                                ? (translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren) | translate)
                                : globalMenuItemChildren.shownText
                        }}"
            [matTooltipDisabled]="showGlobalMenuTexts"
            [matTooltipPosition]="'right'"
            (click)="onClickSubMenu(globalMenuItemChildren)">
            <!--
            TODO
            In der Backend Config gibt es noch veraltete Icons, die man auf FaIcon umziehen muss
            Deshalb wird unten zwischen den alten Icons und den neuen faIcons differenziert
            -->
            @if (globalMenuItemChildren.faIcon) {
              <fa-icon
                class="cw-global-menu-list-icon"
              [icon]="$any(globalMenuItemChildren.faIcon)"></fa-icon>
            }
            @if (globalMenuItemChildren.icon) {
              <div
              class="cw-global-menu-list-icon {{ globalMenuItemChildren.icon }}"></div>
            }
            <span [hidden]="!showGlobalMenuTexts" class="cw-global-menu-list-text">
              {{ (translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren) | translate) !== translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren)
              ? (translateMenuItemToTranslationKey(globalMenuItem, globalMenuItemChildren) | translate)
              : globalMenuItemChildren.shownText }}
            </span>
          </span>
        </li>
      }
    }
  }
</ul>

<!-- Ein-/Ausklappen -->
<div class="cw-flex-row cw-global-menu-toggle" (click)="toggleGlobalMenu()">
  <div class="cw-global-menu-list-icon icon-extend"></div>
  <span [hidden]="!showGlobalMenuTexts" class="cw-global-menu-list-text">{{ 'GENERAL.COLLAPSE' | translate }}</span>
</div>
